import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgEyeClosedinline = (props) => /* @__PURE__ */ _jsx("svg", {
	viewBox: "0 0 24 24",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		d: "M3.044 9.036C5.395 6.346 8.381 5 12 5c3.644 0 6.645 1.364 9.003 4.09M23 12c-2.933 4.667-6.6 7-11 7s-8.067-2.333-11-7m11 7v3m-5-4l-1 3m-3-5l-2 2m16 0l1 3m3-5l2 2",
		fill: "none",
		strokeLinecap: "square",
		strokeLinejoin: "round",
		stroke: "currentColor",
		strokeWidth: 2
	})
});
export default SvgEyeClosedinline;
